import React, { useLayoutEffect, useRef, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

// Limita a altura de conteúdos longos, com um botão para expandir.
export function Collapsible({ maxHeight = 560, children }) {
  const ref = useRef(null);
  const [overflows, setOverflows] = useState(false);
  const [open, setOpen] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const check = () => setOverflows(el.scrollHeight > maxHeight + 40);
    check();
    const observer = new ResizeObserver(check);
    observer.observe(el);
    return () => observer.disconnect();
  }, [maxHeight, children]);

  const collapsed = overflows && !open;

  return (
    <div className={`ss-collapsible ${collapsed ? 'ss-collapsible--collapsed' : ''}`}>
      <div ref={ref} className="ss-collapsible__body" style={collapsed ? { maxHeight } : undefined}>
        {children}
      </div>
      {overflows && (
        <div className="ss-collapsible__toggle">
          <button type="button" onClick={() => setOpen(!open)} aria-expanded={open}>
            {open ? <ChevronUp size={16} aria-hidden="true" /> : <ChevronDown size={16} aria-hidden="true" />}
            {open ? 'Recolher' : 'Mostrar tudo'}
          </button>
        </div>
      )}
    </div>
  );
}
